/**
 * Created by ren_zhangjing on 2017/7/5.
 */
const host = '',
  project = '',
  prefix = host + project +'/api/';
  // prefix = host + project +'/api/';
// oldpwd,newpwd,renewpwd
let apis = {
  //2021
 
  Logout: prefix + 'User/Logout', //退出
  TeachList: prefix + 'SignUp/TeachList ', //获取平台

  
  


  
  Study: prefix + 'SignUp/SelectTeach', // 继续教育报名学习
  GetYears: prefix + 'SignUp/GetYears', // 继续教育学习

  GoPay: prefix + 'SignUp/GoPay', //去支付 参数 {teachid,year}
  InvoiceList: prefix + 'Invoice/List', //发票列表
  PostInvoice: prefix + 'Invoice/PostInvoice', //提交发票
  
  Jump: prefix + 'Index/Jump', //登录跳转
  SelectYear: prefix + 'SignUp/SelectYear', //登录跳转
  ToLearn: prefix + 'User/ToLearn', //去学习切换

  GetOpenID: prefix + 'SignUp/GetOpenID', // 获取openid
  WXPay: prefix + 'SignUp/WXPay', // 获取openid
  SignUpPostInvoice: prefix + 'SignUp/PostInvoice', // 收据
  
  ToLearnList: prefix + 'User/ToLearnList', //学习年度
  CreditPrint: prefix + 'Credit/Print', //打印 课程列表
  QRCode: prefix + 'Credit/QRCode', //打印 课程列表
  GXKQRCode: prefix + 'Credit/GXKQRCode', //公需课二维码
  CreditCheck: prefix + 'Credit/Check', //手机端检查
  CreditGXKCheck: prefix + 'Credit/GXKCheck', //手机端检查
  List: prefix + 'Credit/List', //学分列表
  Details: prefix + 'Credit/Details', //查看课程
  //公需课
  GXKList: prefix + 'Credit/GXKList', //学分列表
  GXKDetails: prefix + 'Credit/GXKDetails', //公需课详情
  GXKPrint: prefix + 'Credit/GXKPrint', //公需课打印
  GXKQuery: prefix + 'Credit/GXKQuery', //公需课外面查询 ?name=&cardid=
  GetPayUrl: prefix + 'SignUp/GoPay', //支付
  GetPayCode: prefix + 'SignUp/GetPayCode', //支付二维码
  OrderQuery: prefix + 'SignUp/OrderQuery', //支付
  History: prefix + 'Invoice/History', //支付
  History: prefix + 'Invoice/History', //支付
  Query: prefix + 'Credit/Query', // 学分查询
  ToPublicClass: prefix + 'User/ToPublicClass', //wx=0/1 返回url 不等于空 则可以跳转


  //2024
  Login: prefix + 'User/Login', //登录
  ResetPassword: prefix + 'User/ResetPassword', //重置密码
  UserInfo: prefix + 'User/UserInfo', // 个人信息
  UpdateUserInfo: prefix + 'User/UpdateUserInfo', //提交个人信息
  ChangePassword: prefix + 'User/ChangePassword', //修改密码
  // LoginOut: prefix + 'User/Logout', //退出
  // StudentStyle: prefix + 'User/StudentStyle', //学员风采
  // CourseList: prefix + 'User/CourseList', //课程目录
  newcourselist: prefix + 'User/newcourselist', //课程目录
  //2025
  Register: prefix + 'User/Register', //注册
  CheckReg: prefix + 'User/CheckReg', //检查注册身份证号 post
  
  coursedetailed: prefix + 'User/coursedetailed', //课程列表详细
  signup: prefix + 'User/signup', //报名
  addnumb: prefix + 'User/addnumb', //pdf下载次数
  

  
  //管理端
  register: prefix + 'Manage/register', //登录
  PHASElist: prefix + 'Manage/PHASElist', //培训列表
  GetPhaseDetailed: prefix + 'Manage/GetPhaseDetailed', //查看详细
  DelPHASE: prefix + 'Manage/DelPHASE', //删除
  EditPHASE: prefix + 'Manage/EditPHASE', //新增期数
  UPloadFiles: prefix + 'Manage/UPloadFiles', //上传文件
  EditCourse: prefix + 'Manage/EditCourse', //编辑/新增课程
  DelCourse: prefix + 'Manage/DelCourse', //删除最详细的期数内容
  //培训
  GetTrainingList: prefix + 'training/GetTrainingList', //培训列表
  GetTrainingDetailed: prefix + 'training/GetTrainingDetailed', //培训详情
  GetSignList: prefix + 'training/GetSignList', //签到表
  SignExport: prefix + 'training/SignExport', //导出
  Import: prefix + 'training/Import', //导入
  UserList: prefix + 'training/UserList', //学员列表
  AddUser: prefix + 'training/AddUser', //新增学员
  OperateSign: prefix + 'training/OperateSign', //单课程签到
  DelUser: prefix + 'training/DelUser', //删除用户
  OperateUser: prefix + 'training/OperateUser', //一键操作
  Operatedining: prefix + 'training/Operatedining', //是否用餐
  
  //人员
  Getstaff: prefix + 'staff/Getstaff', //人员管理
  staffImport: prefix + 'staff/staffImport', //人员导入
  staffExport: prefix + 'staff/staffExport', //人员导出
  Delstaff: prefix + 'staff/Delstaff', //删除人员
  GetstaffDetailed: prefix + 'staff/GetstaffDetailed', //人员详细
  Addstaff: prefix + 'staff/Addstaff', //新增学员
  //学员风采
  Getstylelist: prefix + 'StudentStyle/Getstylelist', //学员风采列表
  DelStyle: prefix + 'StudentStyle/DelStyle', //删除文件
  Editstyle: prefix + 'StudentStyle/Editstyle', //修改上传文件
  
  
  //培训学员端最新版
  StudentStyle: prefix + 'User/StudentStyle', //照片墙
  StudentManage: prefix + 'User/StudentManage', //学员管理
  CourseStudentManage: prefix + 'User/CourseStudentManage', //课程管理
  GetQuestionList: prefix + 'User/GetQuestionList', //提问列表
  SubQuestion: prefix + 'User/SubQuestion', //提交问题
  DelQuestion: prefix + 'User/DelQuestion', //删除提问
  Getinformation: prefix + 'User/Getinformation', //学习资料
  GetWork: prefix + 'User/GetWork', //作业提交
  GetExamination: prefix + 'User/GetExamination', //考题
  SubExamination: prefix + 'User/SubExamination', //提交考题
  GetExaminDetail: prefix + 'User/GetExaminDetail', //查看合格试卷
  GetOpinion: prefix + 'User/GetOpinion', //意见建议
  subOpinion: prefix + 'User/subOpinion', //提交意见
  delOpinion: prefix + 'User/delOpinion', //删除意见
  Getphasedetailed: prefix + 'User/Getphasedetailed', //报名详情

  Getphasedetailed2: prefix + 'User/Getphasedetailed2', //报名弹窗详情
  
  

  // 报名
  Checksignup: prefix + 'User/Checksignup', //检查是否报名
  coursesign: prefix + 'User/coursesign', //未注册报名
  getsignup: prefix + 'User/getsignup', //检查是否报名
  Getphase: prefix + 'User/Getphase', //获取报名时间地点
  
  // 管理端考试
  GetExam: prefix + 'Manage/GetExam', //考试信息
  ExamImport: prefix + 'Manage/ExamImport', //导入考题
  DelExam: prefix + 'Manage/DelExam', //删除考题
  EditExam: prefix + 'Manage/EditExam', //修改考题
  IsStartsExam: prefix + 'Manage/IsStartsExam', //修改考题

  GetQuestions: prefix + 'training/GetQuestions', //学员提问
  SubQuestions: prefix + 'training/SubQuestions', //发布回复
  delQuestions: prefix + 'training/delQuestions', //删除提问

  GetExamInfo: prefix + 'training/GetExamInfo', //考试信息
  OperateExam: prefix + 'training/OperateExam', //操作考试
  GetQuestion: prefix + 'training/GetQuestion', //意见建议
  DelQuestion: prefix + 'training/DelQuestion', //删除意见
  GetQuestionExport: prefix + 'training/GetQuestionExport', //导出意见
  GetUserExam: prefix + 'training/GetUserExam', //考试信息

  CreateQrcode: prefix + 'Manage/CreateQrcode', //二维码
  // 学习资料
  
  
  
  
  
  
  
  
  
  
  
};
export default apis;



// WEBPACK FOOTER //
// ./src/api/index.js